// src/services/portfolioService.js
// One-shot portfolio data for the Portfolio dashboard. The backend aggregates
// every exchange + holding server-side (cached), so the page loads with a single
// request instead of orchestrating many live-exchange round-trips.
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASEURL;

const authHeaders = () => ({
  Authorization: localStorage.getItem('token'),
  'Content-Type': 'application/json',
});

const portfolioService = {
  /**
   * Full portfolio model: { asOf, exchanges:[{...holdings}], aggregate }.
   * Scopes (all vs single exchange) are derived client-side from this payload.
   */
  async summary({ fresh = false } = {}) {
    const res = await axios.get(`${API_BASE}/api/portfolio/summary`, {
      params: fresh ? { fresh: 1 } : undefined,
      headers: authHeaders(),
    });
    return res.data;
  },

  /**
   * Equity series for the chart.
   * @param {'1D'|'1W'|'1M'|'1Y'} range
   * @param {number|null} exchangeId  null/undefined = whole-account aggregate
   * @returns {Promise<{range, scope, series:[{t,v}]}>}
   */
  async history(range = '1M', exchangeId = null) {
    const params = { range };
    if (exchangeId != null) params.exchange_id = exchangeId;
    const res = await axios.get(`${API_BASE}/api/portfolio/history`, { params, headers: authHeaders() });
    return res.data;
  },
};

export default portfolioService;
